import { Injectable } from '@angular/core';
import {AbaEnum} from "../enums/aba.enum";
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class NavegacaoPorAbasService {
  private dataSource = new Subject<AbaEnum>();
  public abaAtual = this.dataSource.asObservable();

  constructor() {
    this.dataSource.next(AbaEnum.Agenda);
  }

  public irParaAba(aba: AbaEnum) {
    this.dataSource.next(aba);
  }
}
